<div class="property-completion-container">
  <div class="header">
    <h1>Complete Sales on Payment of Commission</h1>
  </div>

  <!-- Step 1: Upload -->
  <div class="step-container" *ngIf="currentStep === 'upload'">
    <div class="upload-section">
      <div class="upload-icon">
        <i class="pi pi-cloud-upload"></i>
      </div>

      <p-fileUpload
        #fileUpload
        mode="basic"
        chooseLabel="Upload Commission Properties"
        accept=".csv"
        [maxFileSize]="10000000"
        [auto]="false"
        [showUploadButton]="false"
        [showCancelButton]="false"
        (onSelect)="onFileSelect($event, fileUpload)"
        styleClass="custom-file-upload"
      ></p-fileUpload>

      <div class="file-name" *ngIf="uploadedFile">
        <i class="pi pi-search"></i>
        <span>{{ uploadedFile.name }}</span>
      </div>
    </div>

    <div class="actions">
      <p-button
        label="Next"
        [disabled]="!uploadedFile || isLoading"
        [loading]="isLoading"
        (onClick)="onNext()"
        styleClass="p-button-success next-button"
      ></p-button>
      <p-button
        label="Cancel"
        (onClick)="onCancel()"
        styleClass="p-button-text cancel-button"
      ></p-button>
    </div>
  </div>

  <!-- Step 2: Report -->
  <div class="step-container" *ngIf="currentStep === 'report'">
    <div class="stats-section">
      <div class="stats-icon">
        <i class="pi pi-chart-bar"></i>
      </div>

      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">Total Properties</div>
          <div class="stat-value">{{ reportData?.totalProperties || 0 }}</div>
        </div>

        <div class="stat-card">
          <div class="stat-label">Sale Completed</div>
          <div class="stat-value">{{ reportData?.propertiesCompleted || 0 }}</div>
        </div>

        <div class="stat-card highlight">
          <div class="stat-label">Pending Exchange & Complete</div>
          <div class="stat-value">{{ reportData?.pendingExchangeAndComplete || 0 }}</div>
        </div>

        <div class="stat-card highlight">
          <div class="stat-label">Pending Completion Only</div>
          <div class="stat-value">{{ reportData?.pendingCompletionOnly || 0 }}</div>
        </div>
      </div>
    </div>

    <!-- Duplicate warnings -->
    <div class="warning-section" *ngIf="reportData?.duplicateLoopIds?.length">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ reportData?.duplicateLoopIds?.length }} duplicate Loop IDs were removed from processing</span>
    </div>

    <!-- Error details table -->
    <div class="error-section" *ngIf="reportData?.errors?.length">
      <div class="error-header">
        <i class="pi pi-times-circle"></i>
        <span>{{ reportData?.errors?.length }} properties have errors and will not be processed:</span>
      </div>
      <div class="error-table">
        <table>
          <thead>
          <tr>
            <th>Loop ID</th>
            <th>Error</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let error of reportData?.errors">
            <td>{{ error.loopId }}</td>
            <td>{{ error.errorMessage }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="actions">
      <p-button
        label="Auto Complete"
        [disabled]="isLoading || ((reportData?.pendingExchangeAndComplete || 0) === 0 && (reportData?.pendingCompletionOnly || 0) === 0)"
        [loading]="isLoading"
        (onClick)="onAutoComplete()"
        styleClass="p-button-success next-button"
      ></p-button>
      <p-button
        label="Cancel"
        (onClick)="onCancel()"
        styleClass="p-button-text cancel-button"
      ></p-button>
    </div>
  </div>

  <!-- Step 3: Completed -->
  <div class="step-container" *ngIf="currentStep === 'completed'">
    <div class="completion-section">
      <div class="completion-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <h2>Completed</h2>

      <div class="completion-stats" *ngIf="completionResult">
        <p>Successfully processed {{ completionResult.successCount }} of {{ completionResult.totalProcessed }} properties</p>
        <p *ngIf="completionResult.failureCount > 0" class="error-text">
          {{ completionResult.failureCount }} properties failed to complete
        </p>
      </div>

      <p-button
        label="Done"
        (onClick)="reset()"
        styleClass="p-button-success done-button"
      ></p-button>
    </div>
  </div>
</div>
